if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      this.handleMobileVisibility = this.handleMobileVisibility.bind(this);

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      window.removeEventListener('scroll', this.handleMobileVisibility);
      window.removeEventListener('resize', this.handleMobileVisibility);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', this.handleMobileVisibility, { passive: true });
      window.addEventListener('resize', this.handleMobileVisibility);
      window.addEventListener('scroll', StickyAtcPanel.handleScroll, { passive: true });

      this.handleMobileVisibility();
    }

    handleMobileVisibility() {
      if (theme.mediaMatches.md || !this.productForm) return;

      const rect = this.productForm.getBoundingClientRect();
      const extraOffset = 650;

      // Verborgen zolang het formulier nog in beeld is
      // of nog onder de viewport zit.
      const shouldHide = rect.bottom > -extraOffset;

      this.classList.toggle('sticky-atc-panel--out', shouldHide);
    }

    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}